import './ToggleButtons.css';

/**
 * ToggleButtons - Selección entre opciones con botones conectados
 * Similar visual a Tabs segmented, pero semánticamente es un toggle de valor
 *
 * @param {Array} options - Array de { value: string, label: string, icon?: ReactNode }
 * @param {string} value - Valor seleccionado actualmente
 * @param {function} onChange - Callback cuando cambia la selección
 * @param {boolean} disabled - Deshabilitar todos los botones
 * @param {string} className - Clase CSS adicional
 */
export default function ToggleButtons({
  options,
  value,
  onChange,
  disabled = false,
  className = ''
}) {
  return (
    <div className={`toggle-buttons ${disabled ? 'toggle-buttons--disabled' : ''} ${className}`}>
      {options.map((option) => (
        <button
          key={option.value}
          type="button"
          className={`toggle-buttons__btn ${value === option.value ? 'toggle-buttons__btn--active' : ''}`}
          onClick={() => !disabled && onChange(option.value)}
          disabled={disabled}
          data-sfx="button"
        >
          {option.icon && <span className="toggle-buttons__icon">{option.icon}</span>}
          <span>{option.label}</span>
        </button>
      ))}
    </div>
  );
}
